<div class="pagination">
    <button
        (click)="changePage(currentPage - 1)"
        [disabled]="currentPage === 1"
        class="pagination__button button button--tertiary button--icon icon icon--chevron-left"
    >
        <span class="is-vishidden">Previous</span>
    </button>

    <form
        class="pagination__current-page"
        [formGroup]="pagerForm"
    >
        <div class="field">
            <div class="field__label-input-wrap field__label-input-wrap--inline">
                <label
                    for="pagination-current-page"
                    class="label label--inline"
                >
                    Page
                </label>
                <input
                    class="input input--small"
                    mask="0*"
                    [class.input--invalid]="pageError"
                    id="page"
                    name="page"
                    formControlName="page"
                >
            </div>
        </div>
        <span>of {{totalPages}}</span>
    </form>

    <button
        (click)="changePage(currentPage + 1)"
        [disabled]="currentPage === totalPages"
        class="pagination__button button button--tertiary button--icon icon icon--chevron-right"
    >
        <span class="is-vishidden">Next</span>
    </button>
</div>
